import React, { Component, Fragment } from "react";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import { dateToArray, arrayToDate } from "assets/scripts/components/forms/formHelpers";
import { showDate, getDateRange, allowIndividualAccountPayment } from "../utils";
import DatePickerFormGroup from "assets/scripts/components/common/form/DatePickerFormGroup/DatePickerFormGroup";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import RadioFormGroup from "assets/scripts/components/common/form/RadioFormGroup/RadioFormGroup";
import styles from "./PaymentInfoFields.module.less";
import sumBy from "lodash/sumBy";
import FormGroup from "assets/scripts/components/common/form/FormGroup/FormGroup";
import AccountSelector from "./AccountSelector/AccountSelector";
import tryParseNumber from "assets/scripts/utils/tryParseNumber";
import Icon from "assets/scripts/components/presentational/Icon";
import orderBy from "lodash/orderBy";
import keyBy from "lodash/keyBy";
import AccountDetails from "./AccountDetails/AccountDetails";
import ReadonlyFormGroup from "assets/scripts/components/common/form/ReadonlyFormGroup/ReadonlyFormGroup";
const messages = defineMessages({
    creditorLabel: {
        id: "forms.payNow.creditor.label",
        defaultMessage: "Creditor"
    },
    creditorAcctNumLabel: {
        id: "forms.payNow.creditorAccountNumber.label",
        defaultMessage: "Account Number"
    },
    amountLabel: {
        id: "forms.payNow.amount.label",
        defaultMessage: "Amount"
    },
    amountHelp: {
        id: "forms.payNow.amount.help",
        defaultMessage: "Example: 1234.56"
    },
    amountHelpDistributed: {
        id: "forms.payNow.amount.help.distributed",
        defaultMessage: "The payment amount will be distributed among all eligible accounts"
    },
    totalAmountLabel: {
        id: "forms.payNow.totalAmount.label",
        defaultMessage: "Total Amount"
    },
    dateLabel: {
        id: "forms.payNow.date.label",
        defaultMessage: "Date"
    },
    distributeGroupLabel: {
        id: "forms.payNow.paymentInfo.distribute.groupLabel",
        defaultMessage: "Account options"
    },
    distributeTrue: {
        id: "forms.payNow.paymentInfo.distribute.true",
        defaultMessage: "Pay all accounts"
    },
    distributeFalse: {
        id: "forms.payNow.paymentInfo.distribute.false",
        defaultMessage: "Select individual accounts"
    },
    removeAccount: {
        id: "forms.payNow.paymentInfo.amounts.removeAccount",
        defaultMessage: "Remove account"
    },
    settlementAmountLabel: {
        id: "forms.payNow.paymentInfo.settlementAmount.label",
        defaultMessage: "Settlement Amount"
    }
});
const distributeOptions = [
    {
        value: "true",
        label: messages.distributeTrue
    },
    {
        value: "false",
        label: messages.distributeFalse
    }
];
class PaymentInfoFields extends Component {
    constructor() {
        super(...arguments);
        this._foucsId = null;
        this.state = {
            accountSelectorKey: 0
        };
        this._inputRef = (formGroup, acctId) => {
            if (formGroup != null && this._foucsId === acctId) {
                const input = formGroup.getInput();
                if (input != null) {
                    input.focus();
                    input.select();
                }
                this._foucsId = null;
            }
        };
        this._handleAmountChange = (amount) => this.props.onChange({ amount });
        this._handleDateChange = (date) => this.props.onChange({ date: dateToArray(date) });
        this._handleDistributeChange = (distribute) => {
            this.props.onChange({ distribute: distribute === "true" });
        };
        this._handleAmountsChange = (amount, acctId) => {
            this.props.onChange({
                amounts: {
                    ...this.props.value.amounts,
                    [acctId]: amount
                }
            });
        };
        this._handleAddAccount = (account) => {
            const { value } = this.props;
            const { id } = account;
            if (id in value.amounts) {
                return;
            }
            this._foucsId = id;
            // force selector to render as a new instance to prevent it from re-focusing on the selector
            // after closing. we want to focus on the newly added account instead.
            this.setState(prevState => ({
                accountSelectorKey: prevState.accountSelectorKey + 1
            }));
            this.props.onChange({
                amounts: {
                    ...value.amounts,
                    [id]: account.amountDue.toFixed(2)
                },
                amountsOrder: [
                    ...value.amountsOrder,
                    id
                ]
            });
        };
        this._handleRemoveAccount = ({ id }) => {
            const { value } = this.props;
            const amounts = { ...value.amounts };
            delete amounts[id];
            this.props.onChange({
                amounts,
                amountsOrder: value.amountsOrder.filter(it => it !== id)
            });
        };
    }
    render() {
        const { props } = this;
        const { value, errors, backendErrors } = props;
        const date = arrayToDate(value.date);
        const paymentDateRange = getDateRange();
        const { selected, unselected } = this._getAccounts();
        const eligibleAccounts = [...selected, ...unselected];
        const totalAmount = sumBy(Object.values(value.amounts), it => tryParseNumber(it) || 0);
        const forceDistribute = props.settlementOffer != null || !allowIndividualAccountPayment(props.group);
        const distribute = forceDistribute || value.distribute;
        return (<Fragment>
				{eligibleAccounts.length === 1 && (<Fragment>
						{(process.env.CLIENT == null || eligibleAccounts[0].creditor != null) && (<ReadonlyFormGroup label={messages.creditorLabel} value={eligibleAccounts[0].creditor}/>)}
						{process.env.CLIENT == null && (<ReadonlyFormGroup label={messages.creditorAcctNumLabel} value={<AccountNumber value={eligibleAccounts[0].acctNum}/>}/>)}
					</Fragment>)}

				{eligibleAccounts.length > 1 && !forceDistribute && (<RadioFormGroup name="distribute" className={styles.radio} label={false} value={value.distribute ? "true" : "false"} onChange={this._handleDistributeChange} options={distributeOptions} groupLabel={messages.distributeGroupLabel}/>)}

				{distribute && props.settlementOffer == null && (<TextFormGroup name="amount" type="number" label={messages.amountLabel} help={eligibleAccounts.length > 1 ? messages.amountHelpDistributed : messages.amountHelp} value={value.amount} onChange={this._handleAmountChange} error={errors.amount} backendError={backendErrors.amounts} required/>)}

				{!distribute && (<Fragment>
						<FormGroup label={messages.amountLabel} error={errors.amounts.global} value={""} required>
							{({ attrs }) => (<ul id={attrs.id} className={styles.accountBox}>
									{selected.map(account => (<li key={account.id} className={styles.accountBoxItem}>
											<TextFormGroup ref={it => this._inputRef(it, account.id)} name={`amount-${account.id}`} type="number" label={(<Fragment>
														<span className="u-isVisuallyHidden">Amount for </span>
														<AccountDetails account={account}/>
													</Fragment>)} value={account.id in value.amounts ? value.amounts[account.id] : "0.00"} onChange={it => this._handleAmountsChange(it, account.id)} error={errors.amounts.byId[account.id]}/>
											<button type="button" className={styles.removeAccount} onClick={() => this._handleRemoveAccount(account)} title={props.intl.formatMessage(messages.removeAccount)}>
												<span className="u-isVisuallyHidden">
													<FormattedMessage {...messages.removeAccount}/>
												</span>
												<Icon icon="close"/>
											</button>
										</li>))}
									{unselected.length > 0 && (<li className={styles.selector}>
											<AccountSelector key={this.state.accountSelectorKey} accounts={unselected} onSelect={this._handleAddAccount}>
												{selected.length === 0 && (<FormattedMessage id="forms.payNow.amount.selectAccount" defaultMessage="Select an account"/>)}
												{selected.length > 0 && (<FormattedMessage id="forms.payNow.amount.addAccount" defaultMessage="Select another account"/>)}
											</AccountSelector>
										</li>)}
								</ul>)}
						</FormGroup>

						<ReadonlyFormGroup label={messages.totalAmountLabel} value={(<FormattedNumber value={totalAmount} style="currency" currency="USD"/>)}/>
					</Fragment>)}

				{props.settlementOffer != null && (<ReadonlyFormGroup label={messages.settlementAmountLabel} value={(<FormattedNumber value={parseFloat(props.value.amount)} style="currency" currency="USD"/>)}/>)}

				{showDate(props.group, props.settlementOffer != null) && !props.hideDate && (<DatePickerFormGroup name="date" label={messages.dateLabel} value={date == null ? "" : date.format("YYYY-MM-DD")} onChange={this._handleDateChange} error={errors.date} backendError={backendErrors.scheduledTimestampUtc} minDate={paymentDateRange.minDate} maxDate={paymentDateRange.maxDate} required/>)}
			</Fragment>);
    }
    _getAccounts() {
        const { amounts, amountsOrder } = this.props.value;
        const selected = [];
        const unselected = [];
        for (const account of this.props.group.accounts) {
            if (!account.paymentEligible) {
                continue;
            }
            if (account.id in amounts) {
                selected.push(account);
            }
            else {
                unselected.push(account);
            }
        }
        // preserve the order accounts were selected
        const order = keyBy(amountsOrder.map((id, index) => ({
            id,
            index
        })), it => it.id);
        return {
            selected: orderBy(selected, ({ id }) => order[id].index),
            unselected
        };
    }
}
export default injectIntl(PaymentInfoFields);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/PaymentInfoFields/PaymentInfoFields.tsx